// import { deleteCookie } from 'utils/utilCookie'
import { supabase } from '../axios.instance'

const table = 'user_info'

/**
 * 비밀번호 업데이트
 * @param {string} newPassword
 * @param {string} userId
 * @returns {Promise<any|null>}
 */
export const fetchUpdatePassword = async (newPassword, userId) => {
    try {
        const { data, error } = await supabase.auth.updateUser({
            password: newPassword,
        })

        if (error) {
            console.error('Error updating password:', error)
            return null
        }

        if (!data) {
            console.error('No data returned from password update')
            return null
        }

        // Auth 비밀번호 변경 성공 시 user_info 테이블 업데이트
        const { error: updateError } = await supabase
            .from(table)
            .update({ passwd: newPassword })
            .eq('user_id', userId)
            .select()

        if (updateError) {
            console.error('Error updating user_info table:', updateError)
            return null
        }

        return data
    } catch (err) {
        console.error('Unexpected error:', err)
        return null
    }
}

/**
 * 비밀번호 초기화 이메일 요청
 * @param {string} email
 * @returns {Promise<true|false>}
 */
export const requestResetPassword = async email => {
    try {
        const { error } = await supabase.auth.resetPasswordForEmail(email)
        if (error) throw error
        return true
    } catch (error) {
        console.error('resetPasswordForEmail error:', error)
        throw error
    }
}

/**
 * 기존 비밀번호 확인
 * @param {string} email
 * @param {string} password
 * @returns {Promise<boolean>}
 */
export const verifyUserPassword = async (email, password) => {
    try {
        const { error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) return false
        return true
    } catch (error) {
        console.error('verifyUserPassword error:', error)
        return false
    }
}
/** 로그인 요청 */
export const loginUser = async ({ id, password }) => {
    // 이메일 형식인지 확인 (@ 포함 여부)
    const email = id.includes('@') ? id : `${id}@swedulink.com`

    const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
    })

    if (error) {
        throw new Error(error.message)
    }

    return data
}

/** 유저 정보 조회 */
export const getUserById = async userId => {
    const { data, error } = await supabase.from('user_info').select().eq('user_id', userId)

    if (error) {
        throw new Error(error.message)
    }
    return data[0]
}

export const getUserByEmail = async email => {
    const { data, error } = await supabase.rpc('get_user_info', {
        email_param: email,
    })
    if (error) {
        throw new Error(error.message)
    }

    // 비밀번호 제거
    const { passwd, ...userWithoutPassword } = data[0]
    return userWithoutPassword
}

// 로그아웃
export const authSignout = async () => {
    const { data, error } = await supabase.auth.signOut()
    if (error) throw error
    return data
}

// 세션 복원
export const authGetSession = async () => {
    const { data, error } = await supabase.auth.getSession()
    if (error) throw error
    return data
}
